module.exports = __webpack_public_path__ + "8c565d12fa605308c33a54cff1f07468.gif";